import { configureStore } from '@reduxjs/toolkit'
import createSagaMiddleware from 'redux-saga';
import { persistStore } from 'redux-persist';

import reducers from './reducers';
import sagas from './sagas';

// create the saga middleware
const sagaMiddleware = createSagaMiddleware();
const store = configureStore({
  reducer: reducers,
  middleware: (getDefaultMiddleware) => [
    ...getDefaultMiddleware({ serializableCheck: false, immutableCheck: false }),
    sagaMiddleware
  ],
});


sagaMiddleware.run(sagas)

export const persistor = persistStore(store);
export default store;